
import { availableLocales } from 'bits/locale'
import { Component, Prop, Vue } from 'bits/vue'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzIconButton, { OzIconButtonColorScheme, OzIconButtonSizePreset } from 'library/v4/components/OzIconButton.vue'
import OzMenuRows, {
  OzMenuRowsFocusStyle,
  OzMenuRowsRow,
  OzMenuRowsSizePreset,
} from 'library/v4/components/OzMenuRows.vue'
import OzScreenSizeAwarePopoverModal from 'library/v4/components/OzScreenSizeAwarePopoverModal.vue'
import type { PopoverAnchor } from 'types'

@Component({
  components: {
    OzBox,
    OzMenuRows,
    OzIconButton,
    OzScreenSizeAwarePopoverModal,
  },
})
export default class LocaleMenu extends Vue {
  OzBoxColors = OzBoxColors
  OzMenuRowsSizePreset = OzMenuRowsSizePreset
  OzMenuRowsFocusStyle = OzMenuRowsFocusStyle
  OzIconButtonColorScheme = OzIconButtonColorScheme
  OzIconButtonSizePreset = OzIconButtonSizePreset

  @Prop({ default: () => [] }) boxClasses!: string[]
  @Prop({ default: 'en' }) currentLocale!: string
  @Prop({
    default: () => {
      return {}
    },
  })
  anchor!: Partial<PopoverAnchor>

  @Prop({ default: 304 }) width!: number
  @Prop({ default: true }) isPhone!: boolean
  @Prop({ required: true }) windowHeight!: number
  @Prop({ default: undefined }) preferredTrayStartHeight?: number
  @Prop({ default: true }) xBackButton!: boolean
  @Prop({ default: false }) xCloseButton!: boolean
  @Prop({ default: true }) xHeader!: boolean

  get rowData(): OzMenuRowsRow[] {
    return availableLocales.map((locale) => {
      return {
        text: locale.name,
        rightIcon: this.currentLocale === locale.html ? 'checkmark_thicker' : '',
        rightIconHighlighted: true,
        eventPayload: locale.html,
        ref: locale.html,
        testId: `${locale.standard}LanguageMenuRow`,
      }
    })
  }
}
